import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";

const Hdemo = () => {
  const [teachers, setTeachers] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4); // ⭐ NEW


  useEffect(() => {
    axios
      .get("https://topfaculty.co.in/api/teacher-list2.php")
      .then((response) => {
        console.log(response.data);
        setTeachers(response.data);
              setVisibleCount(5); // reset on load

      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

  // useEffect(() => {
  //   // Wait until table data is rendered
  //   if (teachers && teachers.length > 0) {
  //     // Prevent multiple initializations
  //     if ($.fn.DataTable.isDataTable("#example")) {
  //       $("#example").DataTable().destroy(); // destroy previous instance
  //     }

  //     setTimeout(() => {
  //       $("#example").DataTable(); // initialize again
  //     }, 100); // small delay to ensure table is rendered
  //   }
  // }, [teachers]);

  return (
    <>
      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="rs-latest-list">
                <div className="latest-wrap">
                  <div className="shipping-area">
                    <div className="container">
                      <div className="tab-content">
                        <div className="tab-pane active" id="checkout">
                          <div className="row">
                            <h2 className="title pb-40 md-pb-30 uppercase">
                              Choose The Best Plan For You
                            </h2>
                            <div
                              style={{ maxHeight: "799px", overflowY: "auto" }}
                            >
                              <table
                                id="example"
                                className="table table-striped table-bordered"
                                style={{
                                  width: "100%",
                                  boxShadow:
                                    "rgb(227 218 218 / 35%) 1px -13px 14px 0px inset",
                                }}
                              >
                                <thead
                                  style={{
                                    color: "white",
                                    background: "#050b55",
                                  }}
                                >
                                  <tr>
                                    <th>Faculty</th>
                                    <th>Details</th>
                                    <th>Demo Videos</th>
                                    <th>Demo Notes</th>
                                    <th>Visit Teacher</th>
                                  </tr>
                                </thead>
                                <tbody>
                                     {teachers.slice(0, visibleCount).map((teacher, index) => {

                                    // Ensure videoLink is parsed into an actual array
                                    let videoLinks = [];
                                    if (teacher.videoLink) {
                                      try {
                                        videoLinks = JSON.parse(
                                          teacher.videoLink
                                        ); // Parse the string into an array
                                      } catch (error) {
                                        console.log(
                                          "Error parsing video links:",
                                          error
                                        );
                                      }
                                    }

                                    let notesLink = [];
                                    if (teacher.notesLink) {
                                      try {
                                        notesLink = JSON.parse(
                                          teacher.notesLink
                                        ); // Parse the string into an array
                                      } catch (error) {
                                        console.log(
                                          "Error parsing Notes links:",
                                          error
                                        );
                                      }
                                    }

                                    return (
                                      <tr key={index}>
                                        <td style={{ width: "13%" }}>
                                          <img
                                            style={{ width: "78%" }}
                                            src={
                                              teacher.TeacherProfile
                                                ? teacher.TeacherProfile
                                                : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                                            }
                                            alt={teacher.TeacherName}
                                          />
                                        </td>
                                        <td>
                                          <h6
                                            style={{
                                              color: "blue",
                                              fontWeight: "700",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {teacher.TeacherName}
                                          </h6>
                                          <p
                                            style={{
                                              color: "black",
                                              fontWeight: "700",
                                            }}
                                          >
                                            Subject:{" "}
                                            {teacher.TeacherExamination} (
                                            {teacher.TeacherSubject})
                                          </p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                          <strong>
                                            {Array.isArray(videoLinks) &&
                                            videoLinks.length > 0 ? (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                }}
                                              >
                                                {videoLinks.map((link, idx) => (
                                                  <span
                                                    key={idx}
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                  >
                                                    <a
                                                      href={link}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      style={{
                                                        display: "inline-block",
                                                      }}
                                                    >
                                                      <i
                                                        className="fa fa-video-camera"
                                                        style={{
                                                          fontSize: "25px",
                                                          color: "#05a105",
                                                        }}
                                                        aria-hidden="true"
                                                      ></i>
                                                    </a>
                                                  </span>
                                                ))}
                                              </div>
                                            ) : (
                                              <p>No videos available</p>
                                            )}
                                          </strong>
                                        </td>
                                        <td>
                                          <span className="prize">
                                            {Array.isArray(notesLink) &&
                                            notesLink.length > 0 ? (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                }}
                                              >
                                                {notesLink.map(
                                                  (link2, idx2) => (
                                                    <span
                                                      key={idx2}
                                                      style={{
                                                        marginRight: "10px",
                                                      }}
                                                    >
                                                      <a
                                                        href={link2}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <i
                                                          className="fa fa-file-pdf-o"
                                                          style={{
                                                            fontSize: "25px",
                                                            color: "red",
                                                          }}
                                                          aria-hidden="true"
                                                        ></i>
                                                      </a>
                                                    </span>
                                                  )
                                                )}
                                              </div>
                                            ) : (
                                              <p>No Notes available</p>
                                            )}
                                          </span>
                                        </td>
                                        <td>
                                          <Link
                                            // to={`/teacher/${teacher.TeacherName}${teacher.TeacherId}`}
                                            to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                                          >
                                            <h6
                                              style={{
                                                color: "blue",
                                                fontWeight: "700",
                                                fontSize: "18px",
                                              }}
                                            >
                                              <u>
                                                Visit
                                                <i
                                                  className="fa fa-arrow-right"
                                                  aria-hidden="true"
                                                ></i>
                                              </u>
                                            </h6>
                                          </Link>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                                        {teachers.length > visibleCount && (
  <div style={{ textAlign: "center", marginTop: 20 }}>
    <button
      onClick={() => setVisibleCount((prev) => prev + 4)}
      className="btn btn-primary"
    >
Our Related Teachers    </button>
  </div>
)}

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 mb-pt-50 rs-latest-list">
              <h2 className="title pb-50 md-pb-30 uppercase mt-2">
                Our Facilities
              </h2>

              <div id="rs-latest-news" className="rs-latest-news sec-spacer">
                <div className="col-md-12">
                  <div className="news-list-block">
                    <div className="news-list-item">
                      <div className="news-img">
                        <a href="#">
                          <img src="assetsfront/images/f1.png" alt="" />
                        </a>
                      </div>
                      <div className="news-content">
                        <h5 className="news-title">
                          <a href="#">Expert Tutors</a>
                        </h5>

                        <div className="news-desc">
                          <p>
                            Learn from India’s best educators for academic and
                            skill-based courses.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="news-list-item">
                      <div className="news-img">
                        <a href="#">
                          <img src="assetsfront/images/f2.png" alt="" />
                        </a>
                      </div>
                      <div className="news-content">
                        <h5 className="news-title">
                          <a href="#">Flexible Learning</a>
                        </h5>

                        <div className="news-desc">
                          <p>
                            Choose full courses or specific topics and study
                            anytime, anywhere.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="news-list-item">
                      <div className="news-img">
                        <a href="#">
                          <img src="assetsfront/images/f3.png" alt="" />
                        </a>
                      </div>
                      <div className="news-content">
                        <h5 className="news-title">
                          <a href="#">Online Teaching</a>
                        </h5>

                        <div className="news-desc">
                          <p>
                            Teachers can set their own schedule and reach a wide
                            student base.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="news-list-item">
                      <div className="news-img">
                        <a href="#">
                          <img src="assetsfront/images/f4.jpeg" alt="" />
                        </a>
                      </div>
                      <div className="news-content">
                        <h5 className="news-title">
                          <a href="blog-details.html">Coaching Support</a>
                        </h5>

                        <div className="news-desc">
                          <p>
                            Institutes can onboard teachers, manage students,
                            and digitize their courses.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    
    </>
  );
};

export default Hdemo;
